import React, {useEffect, useRef, useState} from "react";
import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import "./index.less";
// const { renderTextLayer } = pdfjsLib;

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const PDFViewer = ({
  url = "",
  pageNum = 1,
  highlightWord = "",
  width = 760,
  scale = 1,
}) => {
  // const canvasRef = useRef(null);
  // const pdf = useRef(null);
  const [scaleFactor] = useState(1);
  // const [loading, setLoading] = useState(true);
  const pageRenderRef = useRef(null);

  useEffect(() => {
    if (url) {
      init(url);
    }
  }, [url]);

  const init = async(url) => {
    const pdf = await pdfjsLib.getDocument({
      data: url,
      cMapUrl: process.env.PUBLIC_PATH + "cmaps/",
      cMapPacked: true,
    }).promise;

    const {_pdfInfo: {numPages}} = pdf;
    for (let _page = 1; _page <= numPages; _page++) {
      await pdf.getPage(_page).then((page) => {
        const viewport = page.getViewport({scale: 2});
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        context.imageSmoothingEnabled = false;
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        const renderContext = {
          canvasContext: context,
          viewport: viewport,
          enableWebGL: true,
          textLayer: {
            renderMode: "svg", // 使用 SVG 渲染文本
          },
        };
        page.render(renderContext);
        const canvasWrapper = document.createElement("div");
        canvasWrapper.classList.add("canvas-wrapper");  // 给 div 添加类名（可选）

        // 将 canvas 插入到 div 中
        canvasWrapper.appendChild(canvas);
        pageRenderRef.current.appendChild(canvasWrapper);
      });
    }
  };

  return (
    <div className="self-pdf-component" ref={pageRenderRef} style={{"--scale-factor": scaleFactor}}>
    </div>
  );
};

export default PDFViewer;
